import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatCurrency',
})
@Injectable({
  providedIn: 'root',
})
export class FormatCurrencyPipe implements PipeTransform {
  transform(value: any): string {
    if (typeof value === 'number') {
      return this.formatNumber(value.toFixed(5));
    } else if (typeof value === 'string' && !isNaN(parseFloat(value))) {
      return this.formatNumber(parseFloat(value).toFixed(5));
    } else {
      return '';
    }
  }

  private formatNumber(value: string): string {
    let [integerPart, decimalPart] = value.split('.');
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    let formattedValue = decimalPart
      ? `${integerPart},${decimalPart}`
      : integerPart;

    formattedValue = formattedValue.replace(/,?0+$/, '');

    return `${formattedValue}`;
  }

  normalizeNumber(value: any): number | null {
    if (value == null) return null;

    if (typeof value === 'string') {
      // quitar separador de miles
      value = value.replace(/\./g, '');
      // cambiar coma decimal por punto
      value = value.replace(/,/g, '.');
    }

    const n = parseFloat(value);
    return isNaN(n) ? null : n;
  }

  parseFechaString(fecha: string): number | null {
    if (!fecha) return null;

    const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = fecha.match(regex);

    if (!match) return null;

    const [, dia, mes, anio] = match;
    return new Date(+anio, +mes - 1, +dia).getTime();
  }
}
